import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';
var OperationService = /** @class */ (function (_super) {
    tslib_1.__extends(OperationService, _super);
    function OperationService(http) {
        var _this = _super.call(this, 'operation', http) || this;
        _this.http = http;
        return _this;
    }
    OperationService.prototype.ngOnInit = function () {
    };
    return OperationService;
}(BaseService));
export { OperationService };
